import type { HybrisCart } from '../models/hybris/hybrisCart';
import type { HybrisCartModification } from '../models/hybris/hybrisCartModification';

import { isProductEqualPredicate } from '../utils/productUtils';

/** Live quantity updates use HybrisCart (`/cartdata`). HybrisCartModification is the Old `/carts` shape (e.g. replaceability). */
export const resolveUpdatedCartItemQuantity = ({
    productId,
    variantId,
    response,
}: {
    productId: string;
    variantId: string | undefined;
    response: HybrisCartModification | HybrisCart;
}): number | undefined => {
    if ('entries' in response) {
        const entry = response.entries?.find((item) =>
            isProductEqualPredicate(item.product.code, item.variance?.code)(productId, variantId),
        );
        return entry?.quantity;
    }

    return response.quantity ?? response.entry?.quantity;
};
